import {DataStatus} from 'platform/components';

import {useSelector} from 'react-redux';

import i18n from '@dms/i18n';
import {selectConditionStructureTemplate, selectStructureSetting} from '@dms/teas';

import {AuditSettings} from '../../VehicleInspectionsDetail/components/AuditSettings';

export const ConditionSettings = () => {
  const template = useSelector(selectConditionStructureTemplate);
  const structureSettingData = useSelector(selectStructureSetting);

  if (!template?.inspectionType) {
    return (
      <DataStatus
        isError
        errorMessage={i18n.t('page.vehicleSettings.labels.missingInspectionType')}
      />
    );
  }

  return (
    <AuditSettings
      type={template.inspectionType}
      templateId={template?.id}
      isCreate={template?.key === null && !structureSettingData}
    />
  );
};
